export default "__VITE_ASSET__DxYHiHEJ__"